import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import FormInputs from '../../components/FormInputs/FormInputs.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class ModalUploadFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      name: '',
      description: '',
      error: false,
    };
    this.handleOnChangeName = this.handleOnChangeName.bind(this);
    this.handleOnChangeDescription = this.handleOnChangeDescription.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  handleOnChangeName(e) {
    this.setState({ name: e.target.value, error: false });
  }

  handleOnChangeDescription(e) {
    this.setState({ description: e.target.value, error: false });
  }

  handleFileChange(e) {
    e.preventDefault();
    this.setState({ file: this.uploadInput.files[0], error: false });
  }

  onSave() {
    if (this.state.name.length === 0 || this.state.description.length === 0 || !this.state.file) {
      this.setState({ error: true });
    } else {
      const data = {
        file: this.state.file,
        name: this.state.name,
        description: this.state.description,
      };
      this.props.saveFile(data);
    }
  }

  render() {
    return (
      <Modal show onHide={() => this.props.closeUpload()} style={{ display: "block", marginTop: "200px" }}>
        <ModalBlockWrapper
          content={
            <div>
              <Modal.Header closeButton>
                <Modal.Title>Subir archivo</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>
                <FormInputs
                  ncols = {['col-md-6', 'col-md-6']}
                  properties = {[
                    {
                      label : 'Nombre',
                      type : 'text',
                      bsClass : "form-control",
                      value : this.state.name,
                      disabled : false,
                      name: 'inicio',
                      onChange : this.handleOnChangeName,
                      error: false,
                    },
                    {
                      label : 'Descripcion',
                      type : 'text',
                      bsClass : "form-control",
                      value : this.state.description,
                      disabled : false,
                      name: 'fin',
                      onChange : this.handleOnChangeDescription,
                      error: false,
                    },
                  ]}
                />
                <FormInputs
                  ncols = {['col-md-12']}
                  properties = {[
                    {
                      label : 'Archivo',
                      type : 'text',
                      bsClass : "form-control",
                      value: this.state.file ? this.state.file.name : 'No se seleccionó ningún archivo..',
                      disabled : true,
                      name: 'archivo',
                      error: false,
                    }
                  ]}
                />
                <span style={{ float: 'left' }}>
                  <input ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} />
                </span>
                <span style={{ float: 'right' }}>
                  <Button onClick={() => this.uploadInput.click()} bsStyle="primary" fill={true}>Seleccionar archivo</Button>
                  <Button disabled={!this.state.file} onClick={() => this.setState({ file: null })} bsStyle="danger" fill={true}>
                    <i className="fa fa-ban"></i>
                  </Button>
                </span>
              </Modal.Body>
              {this.state.error &&
                <div style={{ width: '100%', textAlign: 'center' }}>
                  <small className="text-danger">
                    Llene todos los campos e incluya un archivo!
                  </small>
                </div>
              }
              <Modal.Footer>
                <Button onClick={this.onSave}>Guardar</Button>
              </Modal.Footer>
            </div>
          }
        />
      </Modal>
    );
  }
}

export default ModalUploadFile;



// WEBPACK FOOTER //
// ./src/views/Components/ModalUploadFile.jsx